export default __webpack_public_path__ + "static/media/search-icon-dark.7933ef61.svg";